// load jQuery and popper.js
import 'jquery';
import 'popper.js';

// load Bootstrap
import 'bootstrap';

// load Bootstrap Select
import 'bootstrap-select/js/bootstrap-select';
import 'bootstrap-select/js/i18n/defaults-de_DE';

// load Bootstrap Datepicker
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';

// load Vue.js
import Vue from 'vue';
import {BootstrapVue} from 'bootstrap-vue';
import Multiselect from 'vue-multiselect';

// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.component('v-multiselect', Multiselect);
import './trip-packing-list';
import './trip-remains-list';
import './trip-shopping-list';

// load all CSS
import './app.scss';

// globally enable popovers
$('.trigger-popover').popover({
  container: 'body',
});

// make jQuery globally available
window.$ = window.jQuery = $;
